/* ============================================
   AURA FIT — theme.js
   Built in silence. Move with purpose.
   ============================================ */

// (LOT 5 — nettoyage) Deux blocs morts ont ete retires ici :
//  - STICKY NAV : un listener scroll togglait la classe .scrolled sur #mainNav,
//    mais aucune regle CSS ni logique n'utilisait .scrolled (listener inutile).
//  - REVEAL ON SCROLL : un IntersectionObserver observait .reveal, mais aucun
//    element du markup ne porte la classe .reveal (observer inutile).

// QUICK ADD sur cartes produit : gere UNIQUEMENT par le handler delegue de
// layout/theme.liquid (avec toast + mise a jour du badge). Le handler qui se
// trouvait ici a ete retire pour supprimer le double ajout au panier : deux
// listeners ecoutaient .af-card__quick[data-variant-id] et un clic ajoutait 2x.

// PAGE TRANSITIONS — fade in du main au chargement.
// Le fondu de sortie a la navigation a ete retire : il imposait un delai de
// 350ms a chaque clic de lien (mauvais pour la vitesse percue et l'INP).
// On garde uniquement l'apparition en douceur, desactivee si prefers-reduced-motion.
// IMPORTANT : fondu d'OPACITE seulement. Aucun transform sur <main> : un
// transform (meme translateY(0)) laisse <main> en couche compositee et bloquait
// le scroll tactile sur iOS (il fallait swiper plusieurs fois). On nettoie aussi
// les styles inline a la fin du fondu pour ne rien laisser sur le conteneur.
(function(){
  var mainEl = document.querySelector('main');
  if(!mainEl) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // MOBILE : aucun fondu sur <main>. Une animation d'opacite composite tout le
  // conteneur de scroll pendant sa duree : sur iOS, le premier swipe a l'arrivee
  // de la page n'etait alors pas pris en compte (scroll pas instantane). On
  // affiche <main> immediatement sur mobile. Le fondu reste actif sur desktop.
  if(reduceMotion || (window.innerWidth <= 768)){
    mainEl.style.opacity = '1';
    return;
  }
  mainEl.style.opacity = '0';
  mainEl.style.transition = 'none';
  var cleanup = function(){
    mainEl.style.transition = '';
    mainEl.style.opacity = '';
    mainEl.removeEventListener('transitionend', cleanup);
  };
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      mainEl.style.transition = 'opacity 0.55s cubic-bezier(0.25,0.46,0.45,0.94)';
      mainEl.style.opacity = '1';
      mainEl.addEventListener('transitionend', cleanup);
      // Filet de securite si transitionend ne se declenche pas.
      setTimeout(cleanup, 700);
    });
  });
})();

// SCROLL REVEALS — subtils (opacity + micro translateY, GPU, une seule fois).
// N'agit QUE sur les elements .af-reveal (jamais hero / videos / CTA principaux).
// Si prefers-reduced-motion ou pas d'IntersectionObserver : on montre tout.
(function(){
  var els = document.querySelectorAll('.af-reveal');
  if(!els.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce || !('IntersectionObserver' in window)){
    for(var i = 0; i < els.length; i++){ els[i].classList.add('is-visible'); }
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(el){ obs.observe(el); });
})();

// BOUTON RETOUR UNIFIE — delegue sur [data-af-back] (snippet af-back).
// Historique interne au site si disponible, sinon fallback dynamique (routes.root_url).
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-af-back]');
  if(!btn) return;
  e.preventDefault();
  var fallback = btn.getAttribute('data-fallback') || '/';
  if(document.referrer && document.referrer.indexOf(window.location.host) !== -1){
    history.back();
  } else {
    window.location.href = fallback;
  }
});
